import React, { useState, useEffect } from "react"
import styled from "styled-components"
import Layout from "../components/layout"
import EventForm from "../components/event/eventForm"
import { useQuery, useMutation } from "@apollo/client"
import withApolloClient from "../components/withApolloClient"
import {
  getWishListByIdQuery,
  updateWishlistMutation,
} from "../components/gql/wishlist"
import { withNotification } from "@omnichannel/egr-common-ui"
import { navigate } from "gatsby"
import { add } from "date-fns"
import useLoyaltyList from "../hooks/useLoyaltyList"
import useBranchList from "../hooks/useBranchList"
import useUserInfo from "../hooks/useUserInfo"

const MainBox = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  padding: 1.6rem 0 8rem 0;
  flex-direction: column;
  @media (min-width: 768px) {
    padding: 2.4rem 0 4rem 0;
  }
`

const TitleBox = styled.div`
  display: flex;
  width: 30rem;
  justify-content: center;
  align-items: center;
`

const HeaderBox = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
`

const Title = styled.div`
  display: flex;
  width: 20rem;
  justify-content: center;
  align-items: center;
  font-size: 2rem;
  padding: 0 0 0.4rem 0;
  cursor: pointer;
`

const TabMainContent = styled.div`
  margin-top: 1.4rem;
  display: flex;
  width: 100%;
  max-width: 128rem;
  justify-content: center;
  align-items: center;
  padding: 2.4rem 2rem;
  box-shadow: 0 0 0.4rem rgba(0, 0, 0, 0.2);
  @media (min-width: 768px) {
    margin-top: 2.4rem;
  }
  @media (min-width: 1000px) {
    padding: 2.4rem 4rem;
  }
  @media (min-width: 1300px) {
    padding: 2.4rem 2rem;
  }
  /* background-color: #f8f8f8; */
`

function MainEventUpdateUI(props) {
  const { openNotification } = props.context

  let { id } = props
  const [eventId, setEventId] = useState(id)
  const [mounted, setMounted] = useState(false)
  useEffect(() => {
    if (id) {
      setEventId(id)
    }
  })

  useEffect(() => {
    setMounted(true)
  }, [])

  // console.log("eventId:", eventId)
  const wishlistResult = useQuery(getWishListByIdQuery, {
    variables: { id: eventId },
    // skip: eventId,
    fetchPolicy: "network-only",
  })

  const userInfo = useUserInfo()
  const loyalties = useLoyaltyList()
  const branches = useBranchList()

  // console.log("wishlist result::", wishlistResult)

  const [updateWishlist, { loading: updateWishlistLoading }] = useMutation(
    updateWishlistMutation,
    {
      fetchPolicy: "no-cache",
      onCompleted: result => {
        // console.log("result::", result.updateWishlist)
        openNotification("Update event successful!")
        setTimeout(() => {
          navigate(`/eventdetail/${wishlistResult.data.getWishListbyId._id}`)
        }, 2000)
      },
      onError: error => {
        console.log("error::", error)
        // setDisableProceedToCheckoutBtn(false)
      },
    }
  )

  let minEventDate
  if (!wishlistResult.loading) {
    minEventDate = add(new Date(), {
      days: 3,
    })
  }

  const minDeliveryOrPickupDate = add(new Date(), {
    days: 2,
  })

  const defaultMaxDeliveryOrPickupDate = selectedDate => {
    return add(!selectedDate ? new Date() : selectedDate, {
      days: !selectedDate ? 22 : 9,
    })
  }

  return mounted ? (
    <MainBox>
      <HeaderBox>
        <TitleBox>
          <Title>Update Event</Title>
        </TitleBox>
      </HeaderBox>
      <TabMainContent>
        {!wishlistResult.loading && (
          <EventForm
            onCancel={() =>
              navigate(
                `/eventdetail/${wishlistResult.data.getWishListbyId._id}`
              )
            }
            userInfo={userInfo}
            wishlist={wishlistResult.data.getWishListbyId}
            saveWishlist={updateWishlist}
            saveWishlistLoading={updateWishlistLoading}
            loyalties={loyalties}
            branches={branches}
            openNotification={openNotification}
            minEventDate={minEventDate}
            minDeliveryOrPickupDate={minDeliveryOrPickupDate}
            defaultMaxDeliveryOrPickupDate={defaultMaxDeliveryOrPickupDate}
          />
        )}
      </TabMainContent>
    </MainBox>
  ) : (
    <div></div>
  )
}

const EventUpdateUIWithNofif = withNotification(MainEventUpdateUI)

function EventUpdate(props) {
  return (
    <Layout
      backgroundColor="#fff"
      {...props}
      minHeight="10rem"
      showFooterInMobile={false}
    >
      <EventUpdateUIWithNofif {...props} />
    </Layout>
  )
}

export default withApolloClient(EventUpdate, { client: "wishlistClient" })
